let mobileMenu = null;
let api = null;
let menuElement = null;
let initialized = false;

const mobileViewport = window.matchMedia("(max-width: 1057px)");

/**
 * Initialize.
 */
function initMobileMenu() {
	if (initialized) {
		return true;
	}

	const page = document.querySelector(".wp-site-blocks");
	const theme = window.bds_theme;

	if (
		!page ||
		!theme ||
		typeof theme.menu_items !== "string" ||
		typeof Mmenu !== "function"
	) {
		return false;
	}

	const tempDiv = document.createElement("div");
	tempDiv.innerHTML = theme.menu_items;

	menuElement = tempDiv.firstElementChild;

	if (!menuElement) {
		return false;
	}

	menuElement.classList.add("bds-menu");

	if (!menuElement.id) {
		menuElement.id = "bds-menu";
	}

	mobileMenu = new Mmenu(
		menuElement,
		{
			classNames: {
				selected: "current-menu-item",
			},
			navbar: {
				add: true,
				title: theme.title || "Menu",
				titleLink: "parent",
			},
			offCanvas: {
				position: "left",
			},
			slidingSubmenus: true,
			theme: "theme",
		},
		{
			offCanvas: {
				menu: {
					insertSelector: "body",
					insertMethod: "prepend",
				},
				page: {
					selector: ".wp-site-blocks",
				},
			},
		},
	);

	api = mobileMenu.API;

	// Fade the contents separately from hiding the menu background.
	let exitTimer = null;
	let menuIsOpen = false;

	/**
	 * Convert a CSS time value to milliseconds.
	 * Supports both "200ms" and "0.2s".
	 */
	function cssTimeToMilliseconds(value) {
		const time = value.trim();
		const number = Number.parseFloat(time);

		if (!Number.isFinite(number)) {
			return 0;
		}

		return time.endsWith("ms") ? number : number * 1000;
	}

	/**
	 * Read the longest transform transition, including its delay.
	 */
	function getPageTransitionDuration() {
		const styles = getComputedStyle(page);
		const properties = styles.transitionProperty.split(",");
		const durations = styles.transitionDuration
			.split(",")
			.map(cssTimeToMilliseconds);
		const delays = styles.transitionDelay
			.split(",")
			.map(cssTimeToMilliseconds);

		return properties.reduce(function (longest, property, index) {
			const name = property.trim();

			if (
				name !== "all" &&
				name !== "transform" &&
				name !== "-webkit-transform"
			) {
				return longest;
			}

			const duration = durations[index % durations.length];
			const delay = delays[index % delays.length];

			return Math.max(longest, duration + delay);
		}, 0);
	}

	api.bind("open:before", function () {
		window.clearTimeout(exitTimer);
		exitTimer = null;
		menuIsOpen = true;

		menuElement.classList.remove("bds-menu-closing");
	});

	api.bind("close:before", function () {
		if (!menuIsOpen) {
			return;
		}

		menuIsOpen = false;
		window.clearTimeout(exitTimer);

		menuElement.classList.add("bds-menu-closing");

		const reducedMotion = window.matchMedia(
			"(prefers-reduced-motion: reduce)",
		).matches;

		const contentDuration = reducedMotion
			? 0
			: cssTimeToMilliseconds(
					getComputedStyle(menuElement).getPropertyValue(
						"--bds-menu-exit-duration",
					),
				);

		const pageDuration = getPageTransitionDuration();

		// Keep the purple background until both animations have finished.
		// A small buffer avoids hiding it on the final transition frame.
		const holdDuration = Math.max(contentDuration, pageDuration) + 50;

		exitTimer = window.setTimeout(function () {
			menuElement.classList.remove("bds-menu-closing");
			exitTimer = null;
		}, holdDuration);
	});

	initialized = true;

	/**
	 * Placeholder parent links open their submenu.
	 */
	menuElement.addEventListener(
		"click",
		function (event) {
			if (!(event.target instanceof Element)) {
				return;
			}

			const itemText = event.target.closest(".mm-listitem__text");

			if (
				!itemText ||
				!menuElement.contains(itemText) ||
				itemText.getAttribute("href") !== "#"
			) {
				return;
			}

			const listItem = itemText.closest(".mm-listitem");
			const nextButton = listItem?.querySelector(
				".mm-btn--next, .mm-listitem__btn",
			);
			const panelHref = nextButton?.getAttribute("href");

			if (!panelHref || !panelHref.startsWith("#")) {
				return;
			}

			const panel = document.getElementById(panelHref.slice(1));

			if (!panel || !menuElement.contains(panel)) {
				return;
			}

			event.preventDefault();
			event.stopPropagation();

			api.openPanel(panel);
		},
		true,
	);

	return true;
}

/**
 * Create the mobile menu when needed.
 */
function checkMobileMenu() {
	if (mobileViewport.matches) {
		initMobileMenu();
	} else if (initialized && api) {
		api.close();
	}
}

/**
 * Bind controls.
 */
function setupMobileMenu() {
	document.addEventListener("click", function (event) {
		if (!(event.target instanceof Element)) {
			return;
		}

		const burger = event.target.closest(".bds-menu-icon button");

		if (!burger || !mobileViewport.matches) {
			return;
		}

		event.preventDefault();

		if (initMobileMenu()) {
			api.open();
		}
	});

	/**
	 * Blocker overlay dismissal.
	 * Keep Mmenu's blocker in its original location (do not move it.)
	 */
	document.addEventListener(
		"click",
		function (event) {
			if (!(event.target instanceof Element) || !api) {
				return;
			}

			const blocker = event.target.closest(".mm-wrapper__blocker");

			if (!blocker) {
				return;
			}

			event.preventDefault();
			event.stopPropagation();

			api.close();
		},
		true,
	);

	checkMobileMenu();

	// React only when crossing the breakpoint, not on every resize.
	mobileViewport.addEventListener("change", checkMobileMenu);
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", setupMobileMenu, {
		once: true,
	});
} else {
	setupMobileMenu();
}
